import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useState } from 'react';
import { Icon, LelyIconButton } from '@/common/components';

import './DotMenu.scss';

const ITEM_HEIGHT = 48;

export type DotMenuCustomOptions = {
  title?: string;
  label?: string;
  icon?: string;
  highlight?: boolean;
  onClickFn: (event: any) => void;
} | null;

type Props = {
  title: string;
  options: DotMenuCustomOptions[];
};

const DotMenu = ({ title, options }: Props) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  // Menu doesn't accept a Fragment as a child, which comlicates the underline-tag logic
  const mainOptions = options.slice(0, options.length - 1);
  const lastOption = options[options.length - 1];

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(null);
  };

  return (
    <>
      <LelyIconButton
        size="md"
        data-testid="dot-menu"
        aria-label="more"
        aria-controls={open ? 'long-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
        onClick={handleClick}
        icon="lely-icon-more-horizontal"
        sx={(theme) => ({
          color: theme.palette.text.subtle,
          padding: 0,
        })}
      />
      <Menu
        className="dot-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          paper: {
            style: {
              maxHeight: ITEM_HEIGHT * 4.5,
              minWidth: '180px',
              marginLeft: 0,
            },
          },
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem disableRipple disableTouchRipple disabled role="none">
          {title}
        </MenuItem>

        {mainOptions.map(
          (option) =>
            option && (
              <MenuItem
                key={option.label}
                onClick={(e) => {
                  option.onClickFn(e);
                  handleClose(e);
                }}
              >
                {option.icon && (
                  <Icon
                    name={option.icon}
                    style={{ width: 19, height: 19, marginRight: 5 }}
                  />
                )}
                {option.label}
              </MenuItem>
            ),
        )}

        {lastOption?.highlight && <u className="underline-tag" />}

        {lastOption && (
          <MenuItem
            key={lastOption.label}
            onClick={(e) => {
              lastOption.onClickFn(e);
              handleClose(e);
            }}
          >
            {lastOption.icon && (
              <Icon
                name={lastOption.icon}
                style={{ width: 19, height: 19, marginRight: 5 }}
              />
            )}
            {lastOption.label}
          </MenuItem>
        )}
      </Menu>
    </>
  );
};

export default DotMenu;
